import axiosInstance from "../../../api/AxiosInstance";
import { endpoints } from "../../../services/endpoints";
import { getProductTypesListRequest, getProductTypesListRequestError, getProductTypesListRequestSuccess } from "../../slices/Content/GetProductTypesList";

export const GetProductTypesListApi = () => async (dispatch) => {

    try {
        dispatch(getProductTypesListRequest());
        axiosInstance({
            method: "GET",
            url: endpoints.getProductTypsList,
            headers: { "Content-Type": "application/json" },
        })
            .then((resp) => {
                return dispatch(getProductTypesListRequestSuccess(resp?.data));
            })
            .catch((error) => {
                const _error = {
                    data: error?.response?.data?.message || error?.message,
                    status: error?.response?.status || error?.status,
                };
                return dispatch(getProductTypesListRequestError(_error));
            });
    } catch (error) { }
};
